<template>
  <div class="ebook-view">
    <nav-menu
      :navMenuList="navMenuList"
      @handleSelect="handleSelect"
      :activeIndex="activeIndex"></nav-menu>
    <el-table
      ref="multipleTable1"
      :data="paperbookData"
      tooltip-effect="dark"
      style="width: 100%"
      @select-all="selectAll"
      @select="selectRow"
      @selection-change="selectionChange1">
      <el-table-column
        type="selection"
        width="80">
      </el-table-column>
      <el-table-column
        label="商品信息"
        align="left">
        <template slot-scope="scope">
          <div class="goods-view">
            <div class="left">
              <img :src="scope.row.imgUrl" alt="">
            </div>
            <div class="right">
              <p class="p-describe">
                {{scope.row.describe}}
              </p>
              <p class="p-author">
                {{scope.row.author}}
              </p>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="money"
        label="单价（元）"
        align="center"
        width="150">
        <template slot-scope="scope">
          <span class="rowMoney">
            ￥{{scope.row.money}}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="num"
        align="center"
        label="数量"
        width="150">
        <template slot-scope="scope">
          <div class="number-view">
            <button class="reduce" @click="reduceClick(scope.row.id, scope.row)">－</button>
            <span class="num">
              {{scope.row.num}}
            </span>
            <button class="plus" @click="plusClick(scope.row.id, scope.row)">＋</button>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="address"
        label="金额（元）"
        align="center"
        width="150">
        <template slot-scope="scope">
          <span class="rowMoney" :class="scope.row.select ? 'active' : ''">
            <!-- ￥{{scope.row.money | ride100(scope.row.num)}} -->
            ￥{{ scope.row.totalPrice }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="address"
        align="center"
        label="操作"
        width="200">
        <template slot-scope="scope">
          <div class="cz">
            <span :class="scope.row.isCollection ? 'active' : ''" @click="collection(scope.$index, scope.row.id, scope.row.isCollection)">
              {{scope.row.isCollection ? '已收藏' : '收藏'}}
            </span>
            <br>
            <br>
            <span @click="deleteData(scope.$index, scope.row.id)">删除</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage1"
        :page-size="pageSize"
        layout="prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <div class="all-view">
      <el-checkbox
      class="paperbookAll"
      v-model="paperbookChecked"
      :indeterminate="isIndeterminate1"
      @change="paperbookAllClick">全选</el-checkbox>
      <!-- <el-button class="batchDetele" type="text" @click="batchDetele">批量删除</el-button> -->
      <!-- <el-button class="batchCollection" type="text" @click="batchCollection">加入收藏夹</el-button> -->
      <span class="span-text">
        已选
        <span class="red-text">
          {{paperbookNum}}
        </span>
        件商品
      </span>
      <span class="span-text">
        总计（不含运费）
        <strong class="red-text">￥{{paperbookAllMoney}}</strong>
      </span>
    </div>
    <div class="js">
      <button @click="settlement">添加订单</button>
    </div>
  </div>
</template>
<script>
import NavMenu from '@/base/navmenu/navmenu'
export default {
  name: '',
  components: {
    'nav-menu': NavMenu
  },
  data () {
    return {
      activeName: 'paperbook',
      paperbookChecked: false, // 全选状态
      isIndeterminate1: false, // 半选状态
      paperbookNum: 0,
      paperbookAllMoney: 0,
      currentPage1: 1,
      activeIndex: '1',
      pageSize: 10,
      total: 0,
      navMenuList: [{
        text: '纸质书',
        pathName: 'PaperBook'
      }, {
        text: '电子书',
        pathName: 'EBook'
      }],
      paperbookData: [],
      multipleSelection1: []
    }
  },
  methods: {
    handleClick (tab, event) {
      // console.log(tab, event)
    },
    selectAll (selection) { // table的全选
      selection.forEach(e => {
        e.select = true
      })
      if (selection.length === 0) {
        this.paperbookData.forEach(e => {
          e.select = false
        })
        this.paperbookChecked = false
      } else {
        this.isIndeterminate1 = false
        this.paperbookChecked = true
      }
    },
    reduceClick (id, row) { // 减
      this.paperbookData.forEach(e => {
        if (id === e.id) {
          if (e.num > 1) {
            e.num -= 1
            row.totalPrice = this.ride100(row.money, e.num)
            this.jsAllMoney()
          }
        }
      })
    },
    plusClick (id, row) { // 加
      this.paperbookData.forEach(e => {
        if (id === e.id) {
          e.num += 1
          row.totalPrice = this.ride100(row.money, e.num)
          this.jsAllMoney()
        }
      })
    },
    collection (index, id, isCollection) { // 单个收藏
      if (!isCollection) {
        const userId = this.$store.state.userMsg.id
        const par = `?bookId=${id}&userId=${userId}`
        this.$get(this.$allUrl.addFavorite + par).then(res => {
          if (res.code === '0') {
            this.paperbookData[index].isCollection = true
          } else {
            this.$notify.error({
              title: '失败',
              message: '收藏失败',
              showClose: false,
              duration: 1500
            })
          }
        })
      }
    },
    deleteCart () {
    },
    deleteData (index, id) { // 单个删除
      const self = this
      this.$confirm('是否删除该商品？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false
      }).then(() => {
        const userId = this.$store.state.userMsg.id
        const par = `?bookId=${id}&userId=${userId}&type=1`
        self.$get(this.$allUrl.deleteCart + par).then(res => {
          if (res.code === '0') {
            self.paperbookData.splice(index, 1)
            if (self.paperbookData.length > 0) {
              self.getCartBooks((self.currentPage1 - 1) * self.pageSize)
            } else {
              self.currentPage1 -= 1
              if (self.currentPage1 > 0) {
                self.getCartBooks((self.currentPage1 - 1) * self.pageSize)
              } else {
                self.getCartBooks(0)
              }
            }
            self.paperbookChecked = false
            self.$root.eventHub.$emit('update_shoppingNum')
          } else {
            self.$notify.error({
              title: '失败',
              message: '删除失败',
              showClose: false,
              duration: 1500
            })
          }
        })
      }).catch(() => {})
    },
    selectRow (selection, row) { // 切换多选框状态
      let flag = false
      let len = selection.length
      if (len === 0) {
        this.paperbookChecked = false
        this.isIndeterminate1 = false
      } else if (len === this.paperbookData.length) {
        this.paperbookChecked = true
        this.isIndeterminate1 = false
      } else {
        this.isIndeterminate1 = true
      }
      selection.forEach(e => {
        if (row.id === e.id) {
          flag = true
          row.select = true
        }
      })
      if (!flag) {
        row.select = false
      }
    },
    paperbookAllClick (val) { // 全选
      this.isIndeterminate1 = false
      this.paperbookData.forEach(row => {
        this.$refs.multipleTable1.toggleRowSelection(row, val)
        row.select = val
      })
      this.paperbookNum = val ? this.paperbookData.length : 0
    },
    selectionChange1 (selection) { // table选择项发生变化时会触发该事件
      this.multipleSelection1 = selection
      this.paperbookNum = selection.length
      this.paperbookAllMoney = 0
      this.jsAllMoney()
    },
    jsAllMoney () { // 计算总价
      this.paperbookAllMoney = 0
      this.multipleSelection1.forEach(e => {
        let money = e.money * 100 * e.num
        this.paperbookAllMoney = ((this.paperbookAllMoney * 100) + money) / 100
      })
    },
    // batchDetele () { // 批量删除
    //   if (this.multipleSelection1.length === 0) {
    //     this.$message({
    //       message: '请先选择商品！',
    //       type: 'warning'
    //     })
    //   } else {
    //     this.$confirm('确定要批量删除商品吗?', '提示', {
    //       confirmButtonText: '确定',
    //       cancelButtonText: '取消',
    //       type: 'warning'
    //     }).then(() => {
    //       console.log(this.multipleSelection1)
    //     }).catch(() => {})
    //   }
    // },
    // batchCollection () { // 批量加入收藏夹
    //   if (this.multipleSelection1.length === 0) {
    //     this.$message({
    //       message: '请先选择商品！',
    //       type: 'warning'
    //     })
    //   } else {
    //     this.$confirm('确定要批量加入收藏夹吗?', '提示', {
    //       confirmButtonText: '确定',
    //       cancelButtonText: '取消',
    //       type: 'warning'
    //     }).then(() => {
    //       console.log(this.multipleSelection1)
    //     }).catch(() => {})
    //   }
    // },
    handleCurrentChange (val) { // 分页
      console.log(val)
      const start = (val - 1) * this.pageSize
      this.getCartBooks(start)
    },
    settlement () { // 结算
      if (this.multipleSelection1.length === 0) {
        this.$message({
          message: '请先选择商品！',
          type: 'warning'
        })
      } else {
        this.$confirm('确定要添加订单吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push({
            path: '/home/orderdetails',
            query: {
              list: JSON.stringify(this.multipleSelection1),
              payAmount: this.paperbookAllMoney,
              bookType: '1'
            }
          })
        }).catch(() => {})
      }
    },
    handleSelect (key) { // 跳转路由
      this.$router.push({
        name: this.navMenuList[key].pathName
      })
    },
    getCartBooks (start) { // 获取电子书购物车数据
      const userId = this.$store.state.userMsg.id
      const pageSize = this.pageSize
      const par = `?type=1&start=${start}&num=${pageSize}&userId=${userId}`
      this.$get(this.$allUrl.getCartBooks + par).then(res => {
        if (res.code === '0') {
          const list = res.data
          const imgAdmin = this.$allUrl.imgAdmin
          this.total = res.recordsTotal
          this.paperbookData = []
          list.forEach(e => {
            this.paperbookData.push({
              id: e.bookId,
              imgUrl: imgAdmin + e.coverUrl,
              name: e.bookName,
              money: e.paperPromotionPrice ? e.paperPromotionPrice : e.bookPrice,
              author: e.bookAuthors,
              num: e.num,
              select: false,
              isCollection: e.favorite !== null,
              describe: e.bookName,
              totalPrice: (e.paperPromotionPrice ? e.paperPromotionPrice : e.bookPrice) * e.num
            })
          })
        }
      })
    },
    ride100 (val, num) {
      return val * 100 * num / 100
    }
  },
  filters: { // 过滤金额
    calculation (val) {
      return val.toFixed(2)
    },
    ride100 (val, num) {
      return val * 100 * num / 100
    }
  },
  mounted () {
    const userId = this.$store.state.userMsg.id
    if (userId) {
      this.getCartBooks(0)
    }
  }
}
</script>
<style lang="less" scoped>
  .ebook-view{
    padding-top: 30px;
    .goods-view{
      display: flex;
      .left{
        img{
          width: 80px;
          height: 110px;
          display: block;
        }
      }
      .right{
        flex: 1;
        padding-left: 30px;
        p{
          padding: 0;
          margin: 0;
        }
        .p-describe{
          color: #000000;
          overflow: hidden;
          word-break: break-all;
          display: -moz-box;
          -moz-box-orient:vertical;
          display: -webkit-box;
          -webkit-box-orient:vertical;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
        }
        .p-author{
          margin-top: 10px;
          color: #666666;
        }
      }
    }
    .number-view{
      text-align: center;
      span{
        display: inline-block;
        line-height: 30px;
        text-align: center;
        vertical-align: middle;
      }
      .reduce, .plus{
        background: #DCDCDC;
        cursor: pointer;
        font-size: 20px;
        font-weight: 600;
        outline: none;
        border: 0;
        line-height: 30px;
        padding: 0;
        margin: 0;
        vertical-align: middle;
      }
      .num{
        height: 28px;
        padding: 0 10px;
        background: white;
        border: 1px solid #DCDCDC;
        margin: 0 -4px 0 -4px;
      }
    }
    .active{
      color: red;
      cursor: auto !important;
    }
    .cz{
      span{
        cursor: pointer;
      }
    }
    .rowMoney{
      font-size: 16px;
    }
    .all-view{
      border: 1px solid #666666;
      border-radius: 6px;
      line-height: 50px;
      padding: 0 40px;
      display: flex;
      button{
        color: black;
      }
      .paperbookAll{
        width: 200px;
      }
      .batchDetele, .batchCollection{
        width: 150px;
      }
      .span-text{
        flex: 1;
        color: #666666;
        font-size: 14px;
        .red-text{
          color: red;
          font-size: 16px;
        }
      }
    }
    .pagination{
      text-align: right;
      padding: 50px 0;
    }
    .js{
      text-align: right;
      padding: 30px 50px;
      button{
        height: 40px;
        width: 100px;
        color: white;
        background: #B7151E;
        border: 0;
        border-radius: 6px;
        font-size: 18px;
        outline: none;
        cursor: pointer;
      }
    }
  }
</style>
<style>
.el-pagination.is-background .el-pager li:not(.disabled).active{
    background: #B7151E !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/ShoppingCart/ebook.vue


// WEBPACK FOOTER //
// src/components/ShoppingCart/ebook.vue